module.exports = __webpack_public_path__ + "static/media/Dog Show Winner.8cf04450.jpg";